import { ImageField, LinkField, StringField } from "../../types/types";
import fieldsMock from "./NotEditableFieldsMock";
import { SpecialOffersSlideFields, SpecialOffersSlideProps, SpecialOffersFields, SpecialOffersProps, SpecialOffersSlideTypeFields, SpecialOffersSlideTypeProps } from "./fields.definitions";
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-react/types/components/Link';

type ValueOf<T> = T[keyof T];
type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
type SpecialOffersSlideGetterFields = Omit<SpecialOffersSlideFields, 'Card Type'>

export class SpecialOffersModel {
    private readonly fields: null | SpecialOffersFields;
    constructor(props: SpecialOffersProps) {
        this.fields = props.fields || null;
    }

    get eyebrow(): StringField | undefined {
        return this.fields?.eyebrow;
    }

    get link(): LinkFieldValue | undefined {
        return this.fields?.link?.value;
    }

    get title(): StringField | undefined {
        return this.fields?.Title;
    }

    get subtitle(): StringField | undefined {
        return this.fields?.Subtitle;
    }

    get items() {
        const defaultValue = fieldsMock.Cards.map((Card) => {
            return new SpecialOffersSlideModel(Card);
        });
        if (this.fields && this.fields['Cards']) {
            return this.fields['Cards'].map((Card) => {
                return new SpecialOffersSlideModel(Card);
            });;
        }
        return defaultValue;
    }
}

export class SpecialOffersSlideModel {
    private readonly fields: null | SpecialOffersSlideFields;
    constructor(props: SpecialOffersSlideProps) {
        this.fields = props.fields || null;
    }

    get type(): StringField | undefined {
        return this.fields?.['Card Type']?.fields?.Key;
    }

    get title(): StringField | undefined {
        return this.fields?.Title;
    }

    get subtitle(): StringField | undefined {
        return this.fields?.Subtitle;
    }

    get label(): StringField | undefined {
        return this.fields?.Label;
    }

    get badgeLink(): LinkField | undefined {
        return this.fields?.['Badge Link'];
    }

    get image(): ImageField | undefined {
        return this.fields?.Image;
    }

    get buttonPrimary(): LinkField | undefined {
        return this.fields?.['Button Primary'];
    }

    get buttonSecondary(): LinkField | undefined {
        return this.fields?.['Button Secondary'];
    }
}

// class SpecialOffersSlideTypeModel {
//     private readonly fields: null | SpecialOffersSlideTypeFields;
//     constructor(props: SpecialOffersSlideTypeProps) {
//         this.fields = props.fields || null;
//     }

//     private getterFn(fieldName: 'Key' | 'Phrase', defaultValue: string): StringField
//     private getterFn(fieldName: keyof SpecialOffersSlideTypeFields, defaultValue: (ValueOf<SpecialOffersSlideTypeFields>)['value'] = '') {
//         if (this.fields && this.fields[fieldName]) {
//             return this.fields[fieldName];
//         }
//         return { value: defaultValue };
//     }

//     get key(): StringField {
//         const defaultValue = fieldsMock.Cards[0].fields["Card Type"].fields.Key.value;
//         return this.getterFn('Key', defaultValue);
//     }

//     get phrase(): StringField {
//         const defaultValue = fieldsMock.Cards[0].fields["Card Type"].fields.Phrase.value;
//         return this.getterFn('Phrase', defaultValue);
//     }
// }
